const muiText = 'MUI X Missing license key';

function getElementByText(text: string) {
  const xpath = `//node()[normalize-space(text())='${text.trim()}']`;
  return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
}

export const deleteTooltipMuiX = () => {
  setTimeout(() => {
    const calendarElement = document.getElementsByClassName('MuiDateRangeCalendar-root');
    const element = getElementByText(muiText);
    element && calendarElement.length && calendarElement[0].removeChild(element);
  });
};